import { render, staticRenderFns } from "./ApprovalNotesTable.vue?vue&type=template&id=18f61e47"
import script from "./ApprovalNotesTable.vue?vue&type=script&lang=js"
export * from "./ApprovalNotesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports